module.exports = {
      id: "comm-health-usage",
      viewBox: "0 0 321.539 50.773",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#comm-health",
      toString: function () {
        return this.url;
      }
    }